/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_PermissionsInputs */

const en_admin_roles_manage_permissions = /** @type {(inputs: Admin_Roles_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

const zh_admin_roles_manage_permissions = /** @type {(inputs: Admin_Roles_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Admin_Roles_Manage_PermissionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions = /** @type {((inputs?: Admin_Roles_Manage_PermissionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_PermissionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_manage_permissions(inputs)
	return zh_admin_roles_manage_permissions(inputs)
});
export { admin_roles_manage_permissions as "admin.roles.manage_permissions" }